import React from "react";
import PropTypes from "prop-types";
import { Anchor } from "hesus-ui-kit";
import {
  SolutionInfoText,
  SolutionTitleText,
  SolutionTitleValue,
} from "./SolutionInfo.styled";
import "../../SolutionView.scss";

const SolutionData = (props) => {
  const { title, text, url } = props;

  return (
    <SolutionInfoText>
      <SolutionTitleText>{`${title} :`}&nbsp; </SolutionTitleText>
      {!url ? (
        <SolutionTitleValue>{text}</SolutionTitleValue>
      ) : (
        <Anchor
          url={url}
          target="_blank"
          rel="noreferrer"
          className="solutions-view__solution-link"
        >
          {text}
        </Anchor>
      )}
    </SolutionInfoText>
  );
};

SolutionData.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
};

SolutionData.defaultProps = {
  text: "",
  url: "",
};
export default SolutionData;
